import Agent from 'components/Agent/Agent.Container';
import Audiences from 'components/Audiences';
import BrandList from 'components/BrandList';
import BrandOverview from 'components/BrandOverview';
import PersonasContainer from 'components/BrandPersonas/BrandPersonas.Container';
import CustomerOverview from 'components/BrandPersonas/CustomerOverview.Container';
import BrandPersonasForm from 'components/BrandPersonasForm/BrandPersonasForm.Container';
import BrandProducts from 'components/BrandProducts';
import BrandTagList from 'components/BrandTags';
import TagDetail from 'components/BrandTags/BrandTagDetail.Container';
import CreateBrandTag from 'components/BrandTags/CreateBrandTag.Container';
import BrandWarningsModal from 'components/BrandWarnings/BrandWarnings.Container';
import BrandWorkflows from 'components/BrandWorkflows';
import WorkflowRunHistory from 'components/BrandWorkflows/WorkflowRunHistory';
import CreativeEngine from 'components/CreativeEngine';
import CustomAudiences, {
  CreateCustomAudience,
  CustomAudienceDetails
} from 'components/CustomAudiences';
import Debug from 'components/Debug';
// Sub-routes
import FacebookTable from 'components/FacebookTable';
import Insights from 'components/Insights/Charts';
import Trends from 'components/Insights/Trends';
import NavigationHeaderWrapper from 'components/NavigationHeader';
import NotFound from 'components/NotFound';
import UserProfile from 'components/UserProfile';
import { Navigate, Outlet, Route, Routes } from 'react-router';
import BrandLoader from './BrandLoader';
import Logout from './LogoutRoute';
import ProtectedRoute from './ProtectedRoute';
import RouterWrapper from './RouterWrapper';

const Router = () => (
  <RouterWrapper>
    <Routes>
      {/* SINGLE ROUTE MODS */}
      <Route element={<ProtectedRoute component={Outlet} />}>
        <Route element={<NavigationHeaderWrapper />}>
          <Route index element={<Navigate to="/brands" />} />
          <Route path="/" element={<Navigate to="/brands" />} />
          <Route path="brands" element={<BrandList />} />
          <Route path="brand-tags" element={<BrandTagList />} />
          <Route path="brand">
            <Route index element={<Navigate to="/brands" />} />
            <Route path=":brandId" element={<BrandLoader />}>
              <Route index element={<BrandOverview />} />
              <Route path="overview" element={<BrandOverview />} />

              <Route path="manage" element={<FacebookTable />} />
              <Route path="audiences" element={<Audiences />} />
              <Route path="custom-audiences" element={<CustomAudiences />} />
              <Route path="custom-audiences/new" element={<CreateCustomAudience />} />
              <Route path="custom-audiences/:definitionId" element={<CustomAudienceDetails />} />
              <Route path="agent" element={<Agent />} />
              <Route path="insights">
                <Route index element={<Navigate to="chart" />} />
                <Route path="chart" element={<Insights />} />
                <Route path="trends" element={<Trends />} />
              </Route>
              <Route path="products" element={<BrandProducts />} />
              <Route path="warnings" element={<BrandWarningsModal />} />
              <Route path="personas" element={<PersonasContainer />} />
              <Route path="personas-form" element={<BrandPersonasForm />} />
              <Route path="customer-overview" element={<CustomerOverview />} />
              <Route path="creative-engine" element={<CreativeEngine />} />
              <Route path="workflows" element={<BrandWorkflows />} />
              <Route path="workflows/:workflowType" element={<WorkflowRunHistory />} />
            </Route>
          </Route>

          <Route path="profile" element={<UserProfile />} />
          <Route path="debug" element={<Debug />} />
          <Route path="brand-tags/create" element={<CreateBrandTag />} />
          <Route path="brand-tags/:tagId" element={<TagDetail />} />
          <Route path="*" element={<Navigate to="/brands" />} />
        </Route>
      </Route>
      {/* AUX ROUTE TO LOG USER OUT */}
      <Route path="logout" element={<Logout />} />
      {/* FALLBACK ROUTE */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </RouterWrapper>
);

export default Router;
